package br.com.texeratx.boardgametimeapp.ui.screens.matches.detail

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import br.com.texeratx.boardgametimeapp.ui.screens.matches.edit.MatchEditScreen
import br.com.texeratx.boardgametimeapp.ui.screens.matches.model.MatchListItemUI
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppSnackbarTone
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEventBus
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class MatchDetailScreen(
    private val initialMatch: MatchListItemUI
) : Screen {

    @Composable
    override fun Content() {

        val navigator = LocalNavigator.currentOrThrow
        val viewModel = koinInject<MatchDetailViewModel>()

        val match by viewModel.match.collectAsState()
        val state by viewModel.state.collectAsState()

        // 🔁 Primeira carga
        LaunchedEffect(Unit) {
            viewModel.setMatch(initialMatch)
        }

        // ⚠️ Fallback enquanto carrega
        val currentMatch = match ?: initialMatch

        MatchDetailUI(
            match = currentMatch,
            state = state,
            onBack = { navigator.pop() },
            onEdit = {
                navigator.push(
                    MatchEditScreen(
                        match = currentMatch,
                        onMatchUpdated = { updated ->
                            // 🔥 ATUALIZA A FONTE ÚNICA
                            viewModel.updateMatch(updated)
                        }
                    )
                )
            },
            onDeleteClick = { viewModel.showDeleteConfirmation() },
            showDeleteConfirmation = state.showDeleteConfirmation,
            isDeleting = state.isDeleting,
            onDismissDeleteConfirmation = { viewModel.dismissDeleteConfirmation() },
            onConfirmDelete = {
                viewModel.dismissDeleteConfirmation()
                viewModel.deleteMatch {
                    navigator.pop()
                    AppUiEventBus.publishMessage(
                        message = "Partida excluída com sucesso.",
                        tone = AppSnackbarTone.Success
                    )
                }
            }
        )
    }
}


